<template>
    <div class="robbing">
        <div class="item" v-for="item in list" :key="item.name">
            <div style="text-align: center;">
                <div class="express-company">{{item.name}}</div>
            </div>
            <div class="weui-cells">
                <div class="weui-cell weui-cell_access">
                    <div class="weui-cell__bd">
                        待取件
                    </div>
                    <div class="weui-cell__hd">{{item.toPickupCount}}
                    </div>
                </div>
                <div class="weui-cell weui-cell_access">
                    <div class="weui-cell__bd">
                        派送中
                    </div>
                    <div class="weui-cell__hd">{{item.sendingCount}}
                    </div>
                </div>
                <div class="weui-cell weui-cell_access">
                    <div class="weui-cell__bd">
                        待签收
                    </div>
                    <div class="weui-cell__hd">{{item.toSignCount}}
                    </div>
                </div>
                <div class="weui-cell weui-cell_access">
                    <div class="weui-cell__bd">
                        已完成
                    </div>
                    <div class="weui-cell__hd">{{item.completeCount}}
                    </div>
                </div>
            </div>
        </div>

        <div class="weui-footer" v-if="!haveData">
            <p class="weui-footer__links">
                <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
            </p>
            <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
        </div>
    </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      year: moment().format("YYYY"),
      haveData: true,
      list: []
    };
  },
  created() {
    let loading = weui.loading("数据加载中", {
      className: "custom-classname"
    });
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    axios
      .get("/api/building/status/paotui")
      .then(res => {
        loading.hide(function() {});
        if (res.data.success) {
          this.list = res.data.data;
        } else {
          this.haveData = false;
          weui.alert(res.data.message);
        }
      })
      .catch(err => {
        this.haveData = false;
        loading.hide(function() {});
        weui.alert("获取统计数据失败");
      });
  },
  methods: {
    
  }
};
</script>

<style scoped>
.robbing {
  font-size: 14px;
}
.robbing-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  text-align: center;
}
.robbing-nav-item {
  flex: 1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
}
.robbing-nav-item:last-child {
  border-right: none;
}
.robbing-nav-item.select {
  color: red;
  border-bottom: 1px solid red;
}
.item {
  border: 1px solid #1aad19;
  margin: 15px;
}
.item + .item {
  margin-top: 10px;
}
.express-company {
  margin-top: 15px;
  font-size: 22px;
  font-weight: bold;
}
.express-count {
  color: orangered;
  font-weight: bold;
}
.img-container {
  margin-top: 10px;
  margin-bottom: 15px;
}
.img {
  width: 100px;
  height: 100px;
  border-radius: 100px;
}
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.weui-cells {
  margin-bottom: 10px;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
  margin-bottom: 10px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
.weui-cells_form .weui-cell__ft {
  font-size: 17px;
}
</style>


// WEBPACK FOOTER //
// src/components/operations/PaotuiStatusInfo.vue